const variants = {
  tableHeader: {
    fontSize: '12px',
    color: 'gray.700',
    fontWeight: 600,
    lineHeight: '16px',
    textOverflow: 'ellipsis',
  },

  tableData: {
    fontSize: '14px',
    color: 'gray.800',
    fontWeight: 400,
    lineHeight: '24px',
  },
}

export const textTheme = {
  variants,
}
